import { Routes, Route } from "react-router-dom";
import AdminProtectedRoute from "./components/AdminProtectedRoute";
import MasterLayout from "./masterLayout/MasterLayout";

import SignInPage from "./pages/SignInPage";

import ManageDashboard from "./pages/Admin/Company/ManageDashboard.jsx";

import ErrorPage from "./pages/ErrorPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import AdminBankAccount from "./pages/Admin/Micro/AdminBankAccount.jsx";
import AdminDirector from "./pages/Admin/Micro/AdminDirector.jsx";
import ManageEnquiry from "./pages/Admin/Enquiry/ManageEnquiry.jsx";
import FollowUp from "./pages/Admin/Enquiry/FollowUp.jsx";
import ManageEmployee from "./pages/Admin/Micro/Employee/ManageEmployee.jsx";
import ManageEmployeeProfile from "./pages/Admin/Micro/Employee/ManageEmployeeProfile.jsx";
import ManageEmployeeCommission from "./pages/Admin/Micro/Employee/ManageEmployeeCommission.jsx";
import ManageGroup from "./pages/Admin/Micro/Customer/ManageGroup.jsx";
import AddGroup from "./pages/Admin/Micro/Customer/AddGroup.jsx";
import ManageMember from "./pages/Admin/Micro/Customer/ManageMember.jsx";
import AddMember from "./pages/Admin/Micro/Customer/AddMember.jsx";
import GoodsLoan from "./pages/Admin/Micro/Loan/GoodsLoan.jsx";
import CashLoan from "./pages/Admin/Micro/Loan/CashLoan.jsx";
import ApprovedCashLoan from "./pages/Admin/Micro/Loan/ApprovedCashLoan.jsx";
import ApprovedGoodsLoan from "./pages/Admin/Micro/Loan/ApprovedGoodsLoan.jsx";
import TodayCashCollection from "./pages/Admin/Micro/Collection/TodayCashCollection.jsx";
import TodayProductCollection from "./pages/Admin/Micro/Collection/TodayProductCollection.jsx";
import ManageClosedCashAccount from "./pages/Admin/Micro/Closed/ManageClosedCashAccount.jsx";
import ManageClosedProductAccount from "./pages/Admin/Micro/Closed/ManageClosedProductAccount.jsx";
import ManageDealer from "./pages/Admin/Micro/Product/ManageDealer.jsx";
import ManageCategory from "./pages/Admin/Micro/Product/ManageCategory.jsx";
import ManageProduct from "./pages/Admin/Micro/Product/ManageProduct.jsx";
import PurchaseOrder from "./pages/Admin/Micro/Product/PurchaseOrder.jsx";
import ApprovedPurchaseOrder from "./pages/Admin/Micro/Product/ApprovedPurchaseOrder.jsx";
import ManageStore from "./pages/Admin/Micro/Product/ManageStore.jsx";
import UserList from "./pages/Admin/User/UserList.jsx";
import AddNewUser from "./pages/Admin/User/AddNewUser.jsx";
import LoginHistory from "./pages/Admin/User/LoginHistory.jsx";
import BranchReport from "./pages/Admin/Micro/Report/BranchReport.jsx";
import MeetingSheet from "./pages/Admin/Micro/Report/MeetingSheet.jsx";
import ActiveAccount from "./pages/Admin/Micro/Report/ActiveAccount.jsx";
import ClosedAccount from "./pages/Admin/Micro/Report/ClosedAccount.jsx";
import GroupReport from "./pages/Admin/Micro/Report/GroupReport.jsx";
import MemberReport from "./pages/Admin/Micro/Report/MemberReport.jsx";
import FoReport from "./pages/Admin/Micro/Report/FoReport.jsx";
import ManageCompany from "./pages/Admin/Company/ManageCompany.jsx";
import ManageNotification from "./pages/Admin/Notification/ManageNotification.jsx";
import ChangePassword from "./pages/Admin/Company/ChangePassword.jsx";
import TermsConditionPage from "./pages/Admin/Company/TermsConditionPage.jsx";
import ManageBranch from "./pages/Admin/Micro/Branch/ManageBranch.jsx";
import AddBranch from "./pages/Admin/Micro/Branch/AddBranch.jsx";
import AddEmployee from "./pages/Admin/Micro/Employee/AddEmployee.jsx";
import AddDealer from "./pages/Admin/Micro/Product/AddDealer.jsx";
import AddProductLoan from "./pages/Admin/Micro/Loan/AddProductLoan.jsx";
import AddCashLoan from "./pages/Admin/Micro/Loan/AddCashLoan.jsx";
import ProductLoanPayment from "./pages/Admin/Micro/Loan/ProductLoanPayment.jsx";
import CashLoanPayment from "./pages/Admin/Micro/Loan/CashLoanPayment.jsx";
import MeetingSheetResult from "./pages/Admin/Micro/Report/MeetingSheetResult.jsx";
import ManageTodayCollSearch from "./pages/Admin/Micro/Collection/ManageTodayCollSearch.jsx";
import ManageMemberSearch from "./pages/Admin/Micro/Customer/ManageMemberSearch.jsx";
import ManageLoanSearch from "./pages/Admin/Micro/Loan/ManageLoanSearch.jsx";
import AuditHistory from "./pages/Admin/Micro/Setting/AuditHistory.jsx";
import RoleAccess from "./pages/Admin/Micro/Setting/RoleAccess.jsx";
function AppRoutes() {
    return (
        <Routes>
            {/* Login Page */}
            <Route path="/" element={<SignInPage />} />
            <Route path="/adminLogin" element={<SignInPage />} />
            {/* User Routes (With Layout) */}
            {/* <Route element={<UserProtectedRoute />}>

      </Route> */}

            {/* ******* Admin Start ****** */}

            {/* Protected Routes (With Layout) */}
            <Route element={<AdminProtectedRoute />}>
                <Route exact path='/manage-admin-dashboard' element={<ManageDashboard />} />

                <Route exact path='/admindashboard' element={<ManageDashboard />} />

                <Route exact path='/adminbankAccount' element={<AdminBankAccount />} />
                <Route exact path='/admin-director' element={<AdminDirector />} />

                <Route exact path='/managebranch' element={<ManageBranch />} />
                <Route exact path='/addbranch' element={<AddBranch />} />
                <Route exact path='/editbranch/:id' element={<AddBranch />} />

                <Route exact path='/manageenquiry' element={<ManageEnquiry />} />
                <Route exact path='/managefollowup' element={<FollowUp />} />

                <Route exact path='/manage-employee' element={<ManageEmployee />} />
                <Route exact path='/add-employee' element={<AddEmployee />} />
                <Route exact path='/add-employee/:id' element={<AddEmployee />} />

                <Route exact path='/manage-employee-profile' element={<ManageEmployeeProfile />} />
                <Route exact path='/manage-employee-comission' element={<ManageEmployeeCommission />} />

                <Route exact path='/manage-groups' element={<ManageGroup />} />
                <Route exact path='/add-groups' element={<AddGroup />} />
                <Route exact path='/add-member' element={<AddMember />} />
                <Route exact path='/add-member/:id' element={<AddMember />} />
                <Route exact path='/add-groups/:id' element={<AddGroup />} />
                <Route exact path='/manage-member' element={<ManageMember />} />
                <Route exact path='/manage-member-search' element={<ManageMemberSearch />} />


                <Route exact path='/manage-loan-search' element={<ManageLoanSearch />} />
                <Route exact path='/goods-loan' element={<GoodsLoan />} />
                <Route exact path='/add-product-loan' element={<AddProductLoan />} />
                <Route exact path='/add-product-loan/:id' element={<AddProductLoan />} />
                <Route exact path='/product-loan-payment/:id' element={<ProductLoanPayment />} />

                <Route exact path='/cash-loan' element={<CashLoan />} />
                <Route exact path='/add-cash-loan' element={<AddCashLoan />} />
                <Route exact path='/add-cash-loan/:id' element={<AddCashLoan />} />
                <Route exact path='/cash-loan-payment/:id' element={<CashLoanPayment />} />

                <Route exact path='/approved-cash-loan' element={<ApprovedCashLoan />} />
                <Route exact path='/approved-goods-loan' element={<ApprovedGoodsLoan />} />


                <Route exact path='/manage-today-coll-search' element={<ManageTodayCollSearch />} />
                <Route exact path='/manage-today-cash-coll' element={<TodayCashCollection />} />
                <Route exact path='/manage-today-product-coll' element={<TodayProductCollection />} />

                <Route exact path='/manage-cash-closed-account' element={<ManageClosedCashAccount />} />
                <Route exact path='/manage-product-closed-account' element={<ManageClosedProductAccount />} />

                <Route exact path='/add-dealer' element={<AddDealer />} />
                <Route exact path='/add-dealer/:id' element={<AddDealer />} />
                <Route exact path='/manage-dealer' element={<ManageDealer />} />

                <Route exact path='/add-category' element={<AddDealer />} />
                <Route exact path='/add-category/:id' element={<AddDealer />} />
                <Route exact path='/manage-category' element={<ManageCategory />} />


                <Route exact path='/manage-product' element={<ManageProduct />} />
                <Route exact path='/purchase-order' element={<PurchaseOrder />} />
                <Route exact path='/approved-purchase-order' element={<ApprovedPurchaseOrder />} />
                <Route exact path='/manage-store' element={<ManageStore />} />

                <Route exact path='/users-list' element={<UserList />} />
                <Route exact path='/add-user' element={<AddNewUser />} />
                <Route exact path='/add-user/:id' element={<AddNewUser />} />

                <Route exact path='/role-access' element={<RoleAccess />} />
                {/* <Route exact path='/assign-role' element={<AssignRole />} /> */}

                <Route exact path='/branch-report' element={<BranchReport />} />
                <Route exact path='/meeting-sheet' element={<MeetingSheet />} />
                <Route exact path="/meeting-sheet-result" element={<MeetingSheetResult />} />
                <Route exact path='/active-account' element={<ActiveAccount />} />
                <Route exact path='/closed-account' element={<ClosedAccount />} />
                <Route exact path='/groups-report' element={<GroupReport />} />
                <Route exact path='/member-report' element={<MemberReport />} />
                <Route exact path='/fo-report' element={<FoReport />} />

                <Route exact path='/company' element={<ManageCompany />} />
                <Route exact path='/notification' element={<ManageNotification />} />
                <Route exact path='/login-history' element={<LoginHistory />} />
                <Route exact path='/change-password' element={<ChangePassword />} />
                <Route exact path='/term-condition' element={<TermsConditionPage />} />
                <Route exact path='/audit-history' element={<AuditHistory />} />

                <Route exact path='*' element={<ErrorPage />} />

            </Route>

            {/* 404 Page */}
            {/* <Route path="*" element={<NotFound />} /> */}
        </Routes>
    );
}
export default AppRoutes;
